import {formatCardNumber, removeCama} from "../../utils/helper";
import PN from "persian-number";

export default function Input({label,label2=null, type, className,lableClass, placeholder, formik, name, dir, disabled = false, readOnly = false, ref, value = null,onBlur=null,icon= null,clickIcon=null,clickButton=null,onChange=null,inputMode=null,iconText=null, showError=true, style={}, labelStyle={}}) {
    const handleBlur = (e) => {
        if(onBlur!==null){
            onBlur()
        }
        formik.handleBlur(e);
    };
    const formatNumber = (value) => {
        const cleaned = value.replace(/,/g, ''); // حذف کاماهای قبلی
        const number = parseInt(cleaned, 10);
        if (isNaN(number)) return '';
        return number.toLocaleString();
    };

    const onChangePrice = (e) => {
        const rawValue = e.target.value.replace(/,/g, '');
        if (!/^\d*$/.test(rawValue)) return; // فقط اعداد مجازند

        const formatted = formatNumber(rawValue);
        formik.setFieldValue(name, formatted);
    };
    // const images = {'627412': "eghtesad-novin.png", '627381': "ansar.png", '505785': "iran-zamin.png", '622106': "parsian.png", '639194': "parsian.png", '627884': "parsian.png", '639347': "pasargad.png", '502229': "pasargad.png", '636214': "ayande.png", '627353': "tejarat.png", '585983': "tejarat.png", '502908': "tosee-taavon.png", '627648': "tosee-saderat-iran.png", '207177': "tosee-saderat-iran.png", '636949': "hekmat.png", '502938': "dey.png", '589463': "refah.png", '621986': "saman.png", '589210': "sepah.png", '639607': "sarmaye.png", '639346': "sina.png", '502806': "shahr.png", '504706': "shahr.png", '603769': "saderat.png", '627961': "sanat-madan.png", '606373': "mehr.png", '639599': "ghavamin.png", '627488': "karafarin.png", '502910': "karafarin.png", '603770': "keshavarzi.png", '639217': "keshavarzi.png", '505416': "gardeshgari.png", '628023': "maskan.png", '610433': "mellat.png", '991975': "mellat.png", '603799': "melli.png", '639370': "mehr-eghtesad.png", '627760': "post-iran.png", '628157': "etebari-tosee.png", '505801': "etebari-kosar.png", '504172': "resalat.png", '585947': "bankino.png",};
    const handleChangeBankCardNumber = (e) => {
        const rawValue = e.target.value.replace(/-/g, '');
        if (!/^\d*$/.test(rawValue)) return; // فقط اعداد مجازند
        const formatted = formatCardNumber(rawValue);
        formik.setFieldValue(name, formatted);
        if (onChange)
            onChange(e)
        else
            formik.handleChange(e)
    };
    const isValidCardNumber = () => {
        return 'bankCardNumber' in formik.errors
    }


    iconText = inputMode === 'price' ? 'تومان' : iconText;
    className += inputMode === 'price' ? ' direction-ltr placeholder-align-start' : '';
    // || inputMode === 'bankCardNumber' ? ' direction-ltr placeholder-align-start' : '';
    return (
        <div className="mb-3 position-relative">
            {
                label && <label style={labelStyle} className="form-label">{label}</label>
            }
            {
                label2 && <span className={`form-label text-success text-end w-100 ${lableClass}`}> ( {label2} ) </span>
            }
            <div className="input-group ">
                {/* {formik.values[name] && formik.values[name].replace(/-/g, '').substring(0, 6) in images ?
                    <span className="input-group-text d-flex-center">
                                    <img width={'20px'} src={require(`../../assets/images/banks/${images[formik.values[name].replace(/-/g, '').substring(0, 6)]}`)} />
                                </span>
                    :
                    ""
                } */}
            <input type={type} className={`form-control ${className} ${formik.errors[name] && formik.touched[name] ? "is-invalid" : "is-valid"}`} dir={dir}
                   name={name} placeholder={placeholder} value={value || formik.values[name]?value?value:formik.values[name]:""}
                //    onChange={inputMode === 'price' ? onChangePrice: inputMode === 'bankCardNumber' ? handleChangeBankCardNumber: onChange?onChange:formik.handleChange} disabled={disabled} onBlur={handleBlur} readOnly={readOnly} ref={ref ? ref : null}
                   onChange={inputMode === 'price' ? onChangePrice: onChange?onChange:formik.handleChange} disabled={disabled} onBlur={handleBlur} readOnly={readOnly} ref={ref ? ref : null}
                   autoComplete="off" inputMode={inputMode} style={style} 
                //    maxLength={inputMode === 'bankCardNumber' ? 19 : null}
            />
                {iconText !== null ?
                    <span className="input-group-text cursor-pointer"  ><i className={`bx `}></i>{iconText}</span>
                    :
                    ""
                }
                {icon !== null ?
                    <span className="input-group-text cursor-pointer" onClick={clickIcon} ><i className={`bx ${icon}`}></i></span>
                    :
                    ""
                }
                {inputMode === 'bankCardNumber' ?
                    <button
                        onClick={(e) =>
                        {
                            e.preventDefault();
                            clickButton();
                        }}
                        disabled={isValidCardNumber()} className="btn btn-primary input-group-text">
                        استعلام
                    </button>
                    :
                    ""
                }
            {
                showError && (formik.touched[name] && formik.errors[name] ? (<div className="invalid-feedback">{formik.errors[name]}</div>) : inputMode === 'price' && value ? <div className="invalid-feedback price">{PN.convert(removeCama(value)) + " تومان "}</div> : null)
            }
            </div>
        </div>

    )
}